const SECRET_KEY_PATTERN = /secret|private|seed/i
const SENSITIVE_FIELDS = new Set([
  'password',
  'authorization',
  'proxyauthorization',
  'cookie',
  'cookies',
  'setcookie',
  'token',
  'accesstoken',
  'refreshtoken',
  'apikey',
  'xdiagtoken',
  'proof',
  'signedpayload',
])
const SOLANA_BASE58_ADDRESS = /^[1-9A-HJ-NP-Za-km-z]{32,44}$/
const SOLANA_BASE58_SIGNATURE = /^[1-9A-HJ-NP-Za-km-z]{86,90}$/
const EVM_ADDRESS = /^0x[a-fA-F0-9]{40}$/
const EVM_TX_HASH = /^0x[a-fA-F0-9]{64}$/

/** Keep bounded technical context; never persist authentication/signing material. */
export function redactPii(value: unknown, depth = 0): unknown {
  if (depth > 8) return '<truncated>'
  if (typeof value === 'string') {
    if (EVM_TX_HASH.test(value) || SOLANA_BASE58_SIGNATURE.test(value))
      return `tx:${value.slice(0, 6)}...${value.slice(-4)}`
    if (EVM_ADDRESS.test(value)) return `addr_evm:${value.slice(0, 6)}...${value.slice(-4)}`
    if (SOLANA_BASE58_ADDRESS.test(value))
      return `addr_sol:${value.slice(0, 6)}...${value.slice(-4)}`
    return value.slice(0, 1024)
  }
  if (value === null || typeof value !== 'object') return value
  if (Array.isArray(value)) return value.slice(0, 50).map((item) => redactPii(item, depth + 1))
  return Object.fromEntries(
    Object.entries(value)
      .slice(0, 50)
      .map(([key, child]) => {
        if (
          SECRET_KEY_PATTERN.test(key) ||
          SENSITIVE_FIELDS.has(key.replace(/[-_]/g, '').toLowerCase())
        )
          return [key, '<redacted>']
        // Commit hashes can accidentally match the Base58 wallet-address heuristic.
        if (
          (key.endsWith('ReleaseSha') || key === 'releaseSha') &&
          typeof child === 'string' &&
          /^[a-f\d]{40}$/i.test(child)
        )
          return [key, child]
        return [key, redactPii(child, depth + 1)]
      })
  )
}
